import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
export var ResourceAmount = function (_a) {
    var available = _a.available, required = _a.required, stylePositive = _a.stylePositive, styleNegative = _a.styleNegative;
    var className = Long.fromValue(available).greaterThanOrEqual(required)
        ? stylePositive || IdStyles.TextPositive
        : styleNegative || IdStyles.TextNegative;
    return (React.createElement("div", { className: "resource-requirement" },
        React.createElement(NumberFormat, { amount: required, className: className })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/inventory/resource/ResourceAmount.tsx
// module id = 2641
// module chunks = 3